import SectionBlock from '@/components/ui/section-block';
import { Product } from '@/types';
import { buildHomeListContext } from '@/lib/gtm';
import dynamic from 'next/dynamic';
const ProductsGrid = dynamic(
  () => import('@/components/products/group-products/grid')
);

const ProductsSlider = dynamic(
  () => import('@/components/products/group-products/slider')
);

export default function GroupProducts({
  products,
  title,
  isSlider,
}: Readonly<{
  products: Product[];
  title?: string;
  isSlider?: boolean;
}>) {
  const listContext = buildHomeListContext({
    type: 'handpicked-products',
    title: title || 'handpicked-products',
    order: 200,
  });

  return (
    <SectionBlock title={title}>
      {!isSlider ? (
        <ProductsGrid products={products} listContext={listContext} />
      ) : (
        <ProductsSlider products={products} listContext={listContext} />
      )}
    </SectionBlock>
  );
}
